import React from "react";
import "../../../style/common/_spinner.scss";

const  Spinner = () => {
  return (
    <div className="loading-list">
      <div className="loader loader-1"></div>
    </div>
  )
}
export default Spinner;